import React, {useEffect} from 'react';
import LogsScreen from '../Screens/LogsScreen'
import { connect } from "react-redux";
import get from "../../utils/get";
import * as actions from "../actions/list";

const LogsContainer = (props) => {
  useEffect(() => {
    props.getLogs();
    // eslint-disable-next-line
  }, []);
  return (
    <LogsScreen {...props}/>
  )
}

const mapStateToProps = (state) => ({
  isLoading: get(state, "logs.list.isLoading"),
  data: get(state, "logs.list.data"),
});

const mapActionsToProps = { ...actions };

export default connect(mapStateToProps, mapActionsToProps)(LogsContainer);